import React, { createContext, useContext, useState } from "react";
const AppContext = createContext(void 0);
const AppProviderCalculatorUser = ({ children }) => {
  const [showCommission, setShowCommission] = useState(false);
  const [profitSurebet, setProfitSurebet] = useState(0);
  const [budget, setBudget] = useState(0);
  const [roundTo, setRoundTo] = useState(1);
  const [roundingEnabled, setRoundingEnabled] = useState(false);
  const [selectedBookmaker, setSelectedBookmaker] = useState(-99999999);
  const [editingValues, setEditingValues] = useState({});
  const [editingRoundTo, setEditingRoundTo] = useState(void 0);
  const [valueIsUnacceptable, setValueIsUnacceptable] = useState(false);
  return (
    <AppContext.Provider
      value={{
        showCommission,
        setShowCommission,
        profitSurebet,
        setProfitSurebet,
        budget,
        setBudget,
        roundTo,
        setRoundTo,
        roundingEnabled,
        setRoundingEnabled,
        selectedBookmaker,
        setSelectedBookmaker,
        editingValues,
        setEditingValues,
        editingRoundTo,
        setEditingRoundTo,
        valueIsUnacceptable,
        setValueIsUnacceptable
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
const ContextCalculatorUser = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppProviderCalculatorUser");
  }
  return context;
};
export {
  AppProviderCalculatorUser,
  ContextCalculatorUser
};